import { Component } from "@angular/core";
import { AuthorizeApi } from "../authorize-api";
import { catchError } from "rxjs/operators";
import { of } from "rxjs";
import { Router } from "@angular/router";

@Component({
  selector: "app-logout",
  templateUrl: "./logout.component.html",
  styleUrls: ["./logout.component.scss"],
})
export class LogoutComponent {
  error: boolean = null;

  constructor(api: AuthorizeApi, router: Router) {
    api
      .logout()
      .pipe(
        catchError((error) => {
          console.log(error);
          return of(null);
        })
      )
      .subscribe((x) => {
        if (x) {
          api.connectedUser$.next(null);
          router.navigate(["/"]);
        } else this.error = true;
      });
  }
}
